import { ValueFormatterParams } from "ag-grid-community";
import React, { useRef, useState } from "react";
import Grid from "../../../../components/Grid";
import { ColumnDef, GridHandle } from "../../../../components/Grid/model/Grid";
import Info from "./Info";
import { IHttpRequestQueue } from "./types/types";
import InfoIcon from "../../../../assets/images/infoIcon.svg";
import { useBreadcrumb } from "../../../../hooks/BreadCrumbContext";
import { formatAuditDate, summarizeAuditChanges } from "../../../../shared/auditHistory";

const DATA_PATH = "/listar/auditoriaPatioPorto";
const DEFAULT_FILTERS = {
  response: true,
};

const PatioPortoAudit: React.FC = () => {
  const [selectedRow, setSelectedRow] = useState<IHttpRequestQueue | undefined>();
  const [isInfoOpen, setIsInfoOpen] = useState(false);
  const [isView, setIsView] = useState(false);
  const gridRef = useRef<GridHandle>(null);
  const { addBreadcrumb } = useBreadcrumb();

  const handleUpdate = (_data?: IHttpRequestQueue) => {
    void _data;
  };

  const handleDelete = (_data?: IHttpRequestQueue) => {
    void _data;
  };

  const columns: (ColumnDef & { sort?: string })[] = [
    {
      field: "id_registro",
      headerName: "Identificador",
      filter: true,
      width: 160,
      valueGetter: (params) => params.data?.id ?? params.data?.id_operacao_patio ?? params.data?.id_patio_porto,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) return String(params.value);
        return "-";
      },
    },
    {
      field: "alteracoes",
      headerName: "Alterações",
      filter: false,
      sortable: false,
      width: 560,
      valueGetter: (params) => summarizeAuditChanges(params.data, undefined, DATA_PATH),
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "data_historico",
      headerName: "Data Modificação",
      filter: true,
      filterParams: {
        dateBetween: true,
      },
      width: 220,
      valueFormatter: (params: ValueFormatterParams) => {
        if (params.value) return formatAuditDate(params.value as string);
        return "-";
      },
    },
  ];

  return (
    <>
      {isInfoOpen && (
        <Info
          data={selectedRow}
          title="Detalhes da requisição"
          onClose={() => setIsInfoOpen(false)}
        />
      )}

      {isView && (
        <Info
          data={selectedRow}
          title="Conhecer - Auditoria Pátio Porto"
          onClose={() => setIsView(false)}
        />
      )}

      <div className="flex flex-col w-full h-screen bg-[#F5F5F5] p-5">
        <div className="flex items-center justify-between w-full mb-3">
          <div>
            <h1 className="text-2xl text-[#000000] font-bold">
              Auditoria Patio Porto
            </h1>
          </div>
        </div>

        <div className="flex w-full h-full">
          <Grid
            ref={gridRef}
            columns={columns}
            filters={[]}
            pagination
            path={DATA_PATH}
            customFilters={DEFAULT_FILTERS}
            defaultSortField="data_historico"
            onUpdate={handleUpdate}
            onDelete={handleDelete}
            onView={(data: IHttpRequestQueue) => {
              setSelectedRow(data);
              setIsView(true);
            }}
            status={[]}
            customButtons={[
              {
                label: "Conhecer",
                icon: () => InfoIcon,
                action: (data: IHttpRequestQueue) => {
                  addBreadcrumb("Conhecer");
                  setSelectedRow(data);
                  setIsView(true);
                },
                status: [0],
              },
            ]}
          />
        </div>
      </div>
    </>
  );
};

export default PatioPortoAudit;
